import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/context/AuthContext';
import type { OrgFeatures } from '@/app/api/settings/org-features/route';
import { DEFAULT_REPLY_SUGGESTION_PRESETS } from '@/lib/ai/replySuggestionPresets';

const DEFAULT_FEATURES: OrgFeatures = {
  messaging_enabled: true,
  ai_reply_suggestions_enabled: true,
  ai_reply_suggestion_presets: DEFAULT_REPLY_SUGGESTION_PRESETS,
  meta_ads_self_service: false,
  organization_name: '',
};

export function useOrgFeatures() {
  const { user, loading } = useAuth();

  return useQuery<OrgFeatures>({
    queryKey: ['orgFeatures'],
    queryFn: async () => {
      const res = await fetch('/api/settings/org-features', { credentials: 'include' });
      if (!res.ok) return DEFAULT_FEATURES;
      return res.json() as Promise<OrgFeatures>;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: !loading && !!user,
    placeholderData: DEFAULT_FEATURES,
  });
}
